﻿export const shouldBeCollapsedWhenAllSelected = (
  milestoneId,
  topOnly,
  showOrHideChildren
) => !topOnly && showOrHideChildren?.includes(milestoneId);
